// extracted by mini-css-extract-plugin
export var attachment = "_lh-a";
export var emailContainer = "_lh-4";
export var emailContentPaddedContainer = "_lh-b";
export var emailHeader = "_lh-6";
export var emailIframe = "_lh-3";
export var emailInfoIcon = "_lh-9";
export var emailShortenedSummary = "_lh-e";
export var infoDropdown = "_lh-0";
export var infoRowBoundedContent = "_lh-d";
export var internal = "_lh-5";
export var merchant = "_lh-8";
export var messageInputContainer = "_lh-h";
export var normal = "_lh-7";
export var replyCard = "_lh-f";
export var subtleButton = "_lh-1";
export var subtleButtonIconContainer = "_lh-2";
export var toggleViewRepliesButton = "_lh-c";
export var wrappingText = "_lh-g";